import { Grid } from '@mui/material'
import React from 'react'
import { createWhatsappTemplatePayload, getTemplateDetails } from '../../../models/axiosModel'
import styles from './../../../assets/styles/componentStyles/templatemessages.module.scss'
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import ReplyIcon from '@mui/icons-material/Reply';
import ListIcon from '@mui/icons-material/List';
import CallIcon from '@mui/icons-material/Call';
import templateStyles from './../../../assets/styles/componentStyles/templatemessages.module.scss'
import templatePreviewStyles from './../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import { replacingTemplateMarkdownText } from '../../../utils/constants';
import TemplateButtonPreview from '../channels/global/whatsapp/templates/previews/templateButtonPreview';
import TemplatePreviewGlobal from '../channels/global/whatsapp/templates/previews/templatePreviewGlobal';

interface TemplatePreviewInterface {
    metaInformation: getTemplateDetails,
}

const CampaignTemplatePreview = (props: TemplatePreviewInterface) => {

    const messageText = (type: string) => {
        let data, template: string = "";
        if (type?.toLowerCase() === "body") {
            data = props.metaInformation.whatsapp_template_data?.[0].whatsapp_template_body
            template = data.whatsapp_template_body_value
            // Replacing placeholders with sample values
            data.whatsapp_template_body_variable_data.forEach((variable: any) => {
                const placeholder = variable.whatsapp_template_dynamic_variable_key
                const sampleValue = variable.whatsapp_template_dynamic_variable_sample_value;
                template = template?.replaceAll(placeholder, sampleValue);
            });
        } else if (type?.toLowerCase() === "header") {
            data = props.metaInformation.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0];
            template = data.whatsapp_template_header_data_value
            // Replacing placeholders with sample values
            data.whatsapp_template_header_variable_data.forEach((variable: any) => {
                const placeholder = variable.whatsapp_template_dynamic_variable_key
                const sampleValue = variable.whatsapp_template_dynamic_variable_sample_value;
                template = template?.replaceAll(placeholder, sampleValue);
            });
        } else {
            data = props.metaInformation.whatsapp_template_data?.[0].whatsapp_template_footer;
            template = data?.whatsapp_template_footer_value || ""
            // Replacing placeholders with sample values
            // data.whatsapp_template_header_variable_data.forEach((variable: any) => {
            //     const placeholder = variable.whatsapp_template_dynamic_variable_key
            //     const sampleValue = variable.whatsapp_template_dynamic_variable_sample_value;
            //     template = template.replaceAll(placeholder, sampleValue);
            // });
        }
        return replacingTemplateMarkdownText(template);
    }


    const getSubButtonIcon = (whatsapp_template_button_sub_type_id: number | string) => {
        let subId = Number(whatsapp_template_button_sub_type_id)
        switch (subId) {
            case 3:
                return <OpenInNewOutlinedIcon style={{ display: "flex" }} className={styles.previewSubButton} />;
            case 4:
                return <CallIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            case 2:
                return <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            case 1:
                return <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            case null:
                return ""
            default:
                return <ListIcon style={{ display: "flex" }} className={styles.previewSubButton} />
        }

    }

    const getSubButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData.whatsapp_template_button_sub_type_field_data.filter((field: any) => field.field_name == "Button Text")[0]

        switch (fieldVal.field_static_value_flag) {
            case true:
                return fieldVal.field_static_value
            case false:
                return fieldVal.whatsapp_template_button_sub_type_field_value
            default:
                return ""
        }
    }

    return (
        <Grid item padding={"0px"} className={styles.previewSectionCardBlock}>
            <Grid container direction={"column"}>
                <TemplatePreviewGlobal 
                    headerType={props.metaInformation.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_type_name}
                    headerURL={props.metaInformation.whatsapp_template_data[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_data_value || props.metaInformation.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_sample_value}
                    headerVaraibleData={props.metaInformation.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data ?? []}
                    isFooter={props.metaInformation?.whatsapp_template_data?.[0].whatsapp_template_footer && props.metaInformation?.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_value && props.metaInformation?.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_value.length > 0}
                    headerText={messageText("header")}
                    bodyText={messageText("body")}
                    footerText={messageText("footer")}
                />

                {/* {
                    props.metaInformation.whatsapp_template_data[0].whatsapp_template_button.length > 0 && props.metaInformation.whatsapp_template_data[0].whatsapp_template_button.flatMap((btn: any) => btn.whatsapp_template_button_data).length <= 3 && props.metaInformation.whatsapp_template_data[0].whatsapp_template_button.flatMap((btn: any) => btn.whatsapp_template_button_data).map((subBtnData: any, ind: number) => {
                        return <React.Fragment key={ind}>
                            <Grid item paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                    <Grid item>
                                        {getSubButtonIcon(subBtnData.whatsapp_template_button_sub_type_id)}
                                    </Grid>
                                    <Grid item>
                                        {getSubButtonText(subBtnData)}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    })
                }
                {
                    props.metaInformation.whatsapp_template_data[0].whatsapp_template_button.length > 0 && props.metaInformation.whatsapp_template_data[0].whatsapp_template_button.flatMap((btn: any) => btn.whatsapp_template_button_data).length > 3 && props.metaInformation.whatsapp_template_data[0].whatsapp_template_button.flatMap((btn: any) => btn.whatsapp_template_button_data).splice(0, 2).map((subBtnData: any, ind: number) => {
                        return <React.Fragment key={ind}>
                            <Grid item paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                    <Grid item>
                                        {getSubButtonIcon(subBtnData.whatsapp_template_button_sub_type_id)}
                                    </Grid>
                                    <Grid item>
                                        {getSubButtonText(subBtnData)}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    })
                } */}

                <TemplateButtonPreview 
                    buttons={props.metaInformation.whatsapp_template_data[0].whatsapp_template_button}
                    previewType={"campaign"}
                />
            </Grid>
        </Grid>
    )
}

export default CampaignTemplatePreview
